import { Box } from '@mui/material';
import React, { useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';

export const BlogDetail = () => {


    const RecentBlog = [
        {
            img: './assets/images/blog-detail-1.png',
            title: 'The Power of Smart Warehouse Management System in 2024',
            date: '4 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-2.png',
            title: 'Is slower team communication a bad thing?',
            date: '23 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-3.png',
            title: 'Is slower team communication a bad thing?',
            date: '14 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '8 March 2024',
            path: '/blog-detail'
        },
    ]

    const blogTag = [
        {
            tagTitle: 'Development',
            path: '/DevelopBlogList'
        },
        {
            tagTitle: 'Technology',
            path: '/TechBlogList'
        },
        {
            tagTitle: 'HTML',
            path: '/HtmlBlogList'
        },
        {
            tagTitle: 'Branding',
            path: '/BrandBlogList'
        },
        {
            tagTitle: 'PHP',
            path: '/PhpBlogList'
        }
    ]


    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate(); // Hook for programmatic navigation

    // Handle the search input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle form submission (search on Enter key press)
    const handleSearchSubmit = (e) => {
        e.preventDefault();

        // Filter the tags based on the search query
        const filteredTags = blogTag.filter((tag) =>
            tag.tagTitle.toLowerCase().includes(searchQuery.toLowerCase())
        );

        const filteredBlogs = RecentBlog.filter((blog) =>
            blog.title.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Navigate to the search results page with the filtered data
        navigate('/noBlog', {
            state: { searchQuery, filteredTags, filteredBlogs },
        });
    };
    

    return (
        <>
        
            {/* Blog Detail Banner */}
            <section className='blog-detail-page'>
                <div className='blog-detail-bg'>    
                    <div className='c-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='blog-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-2.svg" alt="" />
                    </div>
                    <div className='about-shap-3 blog-det-1'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4 blog-det-1'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 blog-det-1'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <div className='row justify-content-center'>
                            <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11 col-padding'>
                                <div className='blogdetail-content' data-aos="fade-right" data-aos-duration="2000">
                                    <h3>The Future of Web Development: Trends to Watch in 2025 </h3>
                                    <h6>4 March 2025</h6>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>

            <div className='blog-detail-position'>
                <Container>
                    <div className='row justify-content-center'>
                        <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11' data-aos="zoom-in-up" data-aos-duration="2500">
                            <div className='blog-detail-1'>
                                <img src="../assets/images/blog_1.png" alt="" />
                            </div>
                        </div>
                    </div>

                    <div className='blog-detail-padding'>
                        <Row>
                            <div className="col-xl-8 col-lg-7">

                                <p className='blog-para'>Web development is an ever-evolving field shaped by changes in technology, user behaviour, and business needs. As we move into 2025, web development is expected to take a leap forward with innovations that redefine how websites are built, optimized, and experienced. For businesses, startups, and developers alike, staying ahead of these trends is key to delivering cutting-edge solutions. Here are some of the most prominent web development trends that will shape the future. </p>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1500">
                                    <h3>1. AI-Driven Development and Personalization </h3>
                                    <p>Artificial intelligence (AI) is transforming how websites function and engage with users. In 2025, AI will become integral to web development—from chatbots that offer real-time assistance to AI-generated code that helps developers prototype faster. AI is also powering personalization like never before. Websites can now analyse user behaviour and tailor experiences dynamically, improving conversion rates and customer satisfaction. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1650">
                                    <h3>2. Progressive Web Apps (PWAs) </h3>
                                    <p>PWAs combine the best features of web and mobile apps. They work offline, load quickly, and offer a native app-like experience without needing an app store download. As businesses look to offer fast, cost-effective mobile solutions, PWAs are becoming a preferred choice. In 2025, expect PWAs to become more widespread, particularly for eCommerce and content-heavy platforms. </p>
                                </div>
                                
                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1800">
                                    <h3>3. Voice Search and Conversational Interfaces </h3>
                                    <p>With the rise of smart speakers and voice assistants, voice search is no longer a novelty—it’s a necessity. Developers are now optimizing websites for voice search, which requires different SEO strategies and interface designs. Additionally, conversational interfaces (like voice bots and text-based assistants) are being integrated into websites to provide smoother user interaction and accessibility. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1950">
                                    <h3>5. Dark Mode and Visual Preferences </h3>
                                    <p>User interface design is becoming more user-centric than ever. One simple but popular feature is dark mode. In 2025, customizable themes that align with user preferences (light/dark, color schemes, font sizes) will become standard. Offering these options improves usability and accessibility while reducing eye strain. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2100">
                                    <h3>6. Enhanced Cybersecurity </h3>
                                    <p>With cyber threats on the rise, security is a top priority for web development. SSL encryption, two-factor authentication, and real-time threat detection are just the beginning. Developers are now adopting a “security by design” approach—embedding security protocols from the ground up rather than adding them later. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2250">
                                    <h3>7. Headless CMS and API-First Development </h3>
                                    <p>Traditional content management systems (CMS) are being replaced by headless CMS platforms. These decouple the front end and back end, allowing developers to use APIs to deliver content across multiple platforms—web, mobile, IoT, etc. This trend enables faster, more flexible content delivery, especially for businesses with omnichannel strategies. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2400">
                                    <h3>1. AI-Driven Development and Personalization </h3>
                                    <p>Artificial intelligence (AI) is transforming how websites function and engage with users. In 2025, AI will become integral to web development—from chatbots that offer real-time assistance to AI-generated code that helps developers prototype faster. AI is also powering personalization like never before. Websites can now analyse user behaviour and tailor experiences dynamically, improving conversion rates and customer satisfaction. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2550">
                                    <h3>8. Sustainable Web Development </h3>
                                    <p>Sustainability in tech is gaining traction. Web developers are focusing on reducing digital carbon footprints by optimizing code, compressing images, and improving server efficiency. Clean, minimalistic designs that reduce load times and energy usage are becoming not just best practice, but a responsibility. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2700">
                                    <h3>Conclusion  </h3>
                                    <p>Web development in 2025 is about more than just functionality—it’s about creating smart, inclusive, scalable, and secure digital experiences. At IMUII, we embrace these trends to help our clients stay ahead in the digital game. Whether you’re building a new platform or upgrading an existing one, understanding where web development is headed is key to success. </p>
                                </div>

                            </div>
                            <div className="col-xl-4 col-lg-5 mt-30">
                                <div className='ml-lg-30 ml-0'>
                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="3000">
                                        <div className='search-border'>
                                            <h4>Search</h4>
                                            <form className='search-box position-relative' onSubmit={handleSearchSubmit}>
                                                <input className='w-100' placeholder='Search Your Keywords…' type="text" value={searchQuery}  onChange={handleSearchChange} />
                                                <button className='search-icon' type="submit">
                                                    <img src="../assets/images/search-icon.svg" alt="" />
                                                </button>
                                            </form>
                                        </div>
                                    </div>


                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="2500">
                                        <div className='blog-border'>
                                            <h4>Recent Blog</h4>
                                            <div className='border-blog'></div>
                                            <ul>
                                                {RecentBlog.map((blog, index) => (
                                                    <li key={index}>
                                                        <Link to={blog.path}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '13px'
                                                            }}>
                                                                <div className='blog-list-img'>
                                                                    <img src={blog.img} alt="" />
                                                                </div>
                                                                <div className='blog-list-text'>
                                                                    <h6>{blog.title}</h6>
                                                                    <p>{blog.date}</p>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='blog-border' data-aos="fade-up-left" data-aos-duration="2000">
                                        <h4>Tag Cloud</h4>
                                        <div className='border-blog'></div>
                                        
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '10px'
                                        }}>
                                            {
                                                blogTag.map((tag,index) => (
                                                    <Link key={index} to={tag.path}>
                                                        <p className="tag-badge">{tag.tagTitle}</p>
                                                    </Link>
                                                ))
                                            }
                                        </Box>
                                       
                                    </div>
                                </div>
                            </div>
                        </Row>
                        
                    </div>
                </Container>
            </div>
        
        </>
    )
}
